var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.18784 18.4261C5.24141 18.4261 5.29498 18.4207 5.34855 18.4127L9.85391 17.6225C9.90748 17.6118 9.95837 17.5877 9.99587 17.5475L21.3503 6.19302C21.3752 6.16824 21.3949 6.13881 21.4083 6.10641C21.4217 6.074 21.4287 6.03927 21.4287 6.00419C21.4287 5.9691 21.4217 5.93437 21.4083 5.90196C21.3949 5.86956 21.3752 5.84013 21.3503 5.81535L16.8986 1.36088C16.8477 1.30999 16.7807 1.2832 16.7084 1.2832C16.636 1.2832 16.5691 1.30999 16.5182 1.36088L5.16373 12.7153C5.12355 12.7555 5.09944 12.8037 5.08873 12.8573L4.29855 17.3627C4.27249 17.5062 4.2818 17.6538 4.32568 17.7929C4.36955 17.932 4.44666 18.0583 4.55033 18.1609C4.72712 18.3323 4.94944 18.4261 5.18784 18.4261ZM6.99319 13.7546L16.7084 4.04213L18.6718 6.00552L8.95658 15.718L6.57534 16.1386L6.99319 13.7546ZM21.8566 20.6761H2.1423C1.66819 20.6761 1.28516 21.0591 1.28516 21.5332V22.4975C1.28516 22.6153 1.38158 22.7118 1.49944 22.7118H22.4994C22.6173 22.7118 22.7137 22.6153 22.7137 22.4975V21.5332C22.7137 21.0591 22.3307 20.6761 21.8566 20.6761Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.376976ed.svg";
export { ForwardRef as ReactComponent };